import React from "react";

export default function LastDate({ data, elem, credit, onChangeData }) {
  return (
    <div className="mb-2">
      <label for="comentario">
        {data.entryType === "credits" ? "Primer Vencimiento" : elem.label}
        <span className="obligatory"> *</span>
      </label>
      <input
        value={
          data.entryType === "credits" ? credit?.finalDate : data?.finalDate
        }
        type="date"
        className="form-control input-sm textInput especialGroup formHover"
        name={elem.id}
        min={data.entryType === "credits" ? credit?.firstDate : data?.date}
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
        id={elem.id}
      />
    </div>
  );
}
